"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smallContentGrid = exports.defaultContentGrid = void 0;
exports.defaultContentGrid = {
    start: [1, null, null, 2],
    end: [13, null, null, 12],
};
exports.smallContentGrid = {
    start: [1, null, null, 2, 3],
    end: [13, null, null, 12, 11],
};
